import { IAppState } from './types';

export default {
    activePage(state: IAppState) {
        return state.activePage;
    },

    activePartitionIds(state: IAppState) {
        return state.activePartitionIds;
    },

    appError(state: IAppState) {
        return state.appError;
    },

    organizationTokens(state: IAppState) {
        return state.organizationTokens;
    },

    displayView(state: IAppState) {
        return state.displayView;
    },

    chartDateRange(state: IAppState) {
        return state.chartDateRange;
    },
    customFields(state: IAppState) {
        return state.customFields;
    },

    user(state: IAppState) {
        return state.user;
    },

    organization(state: IAppState) {
        return state.organization;
    },

    fileToImport(state: IAppState) {
        return state.fileToImport;
    },

    partitionSets(state: IAppState) {
        return state.partitionSets;
    },
};
